import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BlockUIModule } from 'ng-block-ui';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SafePipe } from './core/pipe/safe.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import {
  DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDropDownBoxModule, DxListModule, DxPopupModule,
  DxSelectBoxModule, DxTagBoxModule, DxTemplateModule, DxTextAreaModule, DxTextBoxModule, DxTreeListModule, DxTreeViewModule, DxDateBoxModule, DxNumberBoxModule
} from 'devextreme-angular';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { NumberOnlyDirective } from './core/directives/number-only.directive';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { AllCoursesComponent } from './pages/all-courses/all-courses.component';
import { BecomeTeacherComponent } from './pages/become-teacher/become-teacher.component';
import { BlogComponent } from './pages/blog/blog.component';
import { ContactComponent } from './pages/contact/contact.component';
import { HomeComponent } from './pages/home/home.component';
import { TeacherDashboardComponent } from './pages/teacher-dashboard/teacher-dashboard.component';
import { LoginComponent } from './pages/login/login.component';
import { TeacherProfileComponent } from './pages/teacher-profile/teacher-profile.component';
import { TeacherCourcesComponent } from './pages/teacher-cources/teacher-cources.component';
import { TeacherSettingsComponent } from './pages/teacher-settings/teacher-settings.component';
import { CreateCourseComponent } from './pages/create-course/create-course.component';
import { CourseDetailsComponent } from './pages/course-details/course-details.component';
import { TeacherViewProfileComponent } from './pages/teacher-view-profile/teacher-view-profile.component';
import { RegisterStudentComponent } from './pages/register-student/register-student.component';
import { StudentProfileComponent } from './pages/student-profile/student-profile.component';
import { Error404Component } from './pages/error404/error404.component';
import { StudentSettingsComponent } from './pages/student-settings/student-settings.component';
import { StudentCourcesComponent } from './pages/student-cources/student-cources.component';
import { DatePipe } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { WishlistComponent } from './pages/wishlist/wishlist.component';
import { RegisterComponent } from './pages/register/register.component';
import { FaqsComponent } from './pages/faqs/faqs.component';
import { CartComponent } from './pages/cart/cart.component';
import { PaymentResultComponent } from './pages/payment-result/payment-result.component';
import { AllNotificationsComponent } from './pages/all-notifications/all-notifications.component';
import { TeacherPaymentsComponent } from './pages/teacher-payments/teacher-payments.component';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
export function tokenGetter() {
  return localStorage.getItem('token');
}

let lang = localStorage.getItem('lang') as string
let val = lang ? lang : 'ar' 

@NgModule({
  declarations: [
    AppComponent,
    SafePipe,
    NumberOnlyDirective,
    AboutUsComponent,
    AllCoursesComponent,
    BecomeTeacherComponent,
    BlogComponent,
    ContactComponent,
    HomeComponent,
    TeacherDashboardComponent,
    LoginComponent,
    TeacherProfileComponent,
    TeacherCourcesComponent,
    TeacherSettingsComponent,
    CreateCourseComponent,
    CourseDetailsComponent,
    TeacherViewProfileComponent,
    RegisterStudentComponent,
    StudentProfileComponent,
    Error404Component,
    StudentSettingsComponent,
    StudentCourcesComponent,
    WishlistComponent,
    RegisterComponent,
    FaqsComponent,
    CartComponent,
    PaymentResultComponent,
    AllNotificationsComponent,
    TeacherPaymentsComponent,
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgxSpinnerModule,
    NgbModule,
    DxTreeViewModule,
    DxTreeListModule,
    DxDateBoxModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxCheckBoxModule,
    DxPopupModule,
    NgxStarRatingModule,
    DxButtonModule,
    DxTextAreaModule,
    DxDropDownBoxModule,
    NgxPaginationModule,
    DxTemplateModule,
    DxListModule,
    DxTagBoxModule,
    DxTextBoxModule,
    BlockUIModule.forRoot(),
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: val, 
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter,
        allowedDomains: [environment.domainUrl],
        disallowedRoutes: [environment.domainUrl + '/api/auth']
      }
    }),
  ],
  providers: [
    DatePipe,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
